import { StyleSheet, View } from 'react-native'
import React from 'react'
import { Theme, ThemedText, ThemedView } from '@app/theme'
import Button from '@app/sharedComponents/Button/Button'
import { useTheme } from '@shopify/restyle'
import CrossIcon from '../../../../assets/Icons/CrossIcon'
import { ThemedTouchableOpacity } from '@app/theme/Components'


const WhyMandate = ({ onClose }: { onClose: () => void }) => {
    const { colors } = useTheme<Theme>();
    return (
        <ThemedView padding='lg'>
            <ThemedText mb='2xl' variant='h5s' color='text-primary'>
                Why setup mandate?
            </ThemedText>
            <ThemedText mb='2xl' variant='b3r' color='text-secondary'>
                With a bank mandate, you can pay your EMIs automatically and on time, avoiding the hassle of manual repayments each month, ensuring a seamless and secure payment experience.
            </ThemedText>
            <Button
                label="Ok, got it!"
                type="OUTLINED"
                size='MD'
                handlePress={onClose}
                bg={colors['bg-action-primary']}
                textColor={colors['text-primary']}
            />
        </ThemedView>
    )
}

export default WhyMandate

const styles = StyleSheet.create({})